import { utilsModule } from "../utils-module";

utilsModule.factory('clientService', ['$q', '$http', 'serverAddress', 'Cliente', 'cacheService',function ($q, $http, serverAddress, Cliente, cacheService) {

    //armazenar locamente a lista de clientes e só carregar se ela já não tiver sido carregada antes
    //consulta muito demorada
    var clientList = undefined;
    var cacheLoaded = undefined;
    //var completedLoadedClientList = {};

    var service:any = {




        listCached: function () {
            var d = $q.defer();
            if (!cacheService.clientList) {
                Cliente.find({ filter: { where:{'ativo':'SIM'} } }).$promise.then(function (list) {
                    cacheService.clientList = list;
                    d.resolve(cacheService.clientList);
                })
            } else {
                d.resolve(cacheService.clientList);
            }
            return d.promise;
        },




        get: function (clientId) {
            var d = $q.defer();
            //Primeiro verifica se o cliente se encontra no cache de clientes já selecionados
            //if (completedLoadedClientList[clientId]) {
            //    d.resolve(completedLoadedClientList[clientId]);
            //} else {

                var listAll = function(){
                    var filter = {
                        where: {
                            _ID_: clientId,
                            'ativo':'SIM'
                        }
                    };
                    $http.get(serverAddress.nodeURL + '/Clientes?filter=' + JSON.stringify(filter)).then(function (response) {
                        if (response.data.length && response.data.length > 0) {
                            //completedLoadedClientList[clientId] = response.data[0];
                            d.resolve(response.data[0]);

                        } else {
                            d.resolve();
                        }
                    }, function () {
                        d.reject();
                    });
                }

                //Se não, verifica se o cache completo de clientes já foi carregado e procura no mesmo
                if (cacheService.clientList) {
                    this.listCached().then((list) => {
                        var filtered = list.filter((cli) => {
                            return cli._ID_ == clientId;
                        });
                        if (filtered && (filtered.length > 0)) {
                            //completedLoadedClientList[clientId] = filtered[0];
                            d.resolve(filtered[0]);
                        } else {
                            listAll();
                        }
                    });
                    //Caso contrário busca o cliente no servidor                    
                } else {
                    listAll();
                }
            // }
            return d.promise;
        },




        getAllWithOnlyBasicInformation: function (where) {
            var d = $q.defer();

            if (clientList != undefined) {
                d.resolve(clientList);
            } else {
                var filter:any = {
                    fields: ['id', 'nomeFantasia','ativo']
                };
                if (where) {
                    filter.where = where;
                }else{
                    filter.where = {}
                }
                filter.where.ativo='SIM';
                $http.get(serverAddress.nodeURL + '/Clientes?filter=' + JSON.stringify(filter)).then(function (response) {
                    d.resolve(response.data);
                }, function () {
                    d.reject();
                });
            }
            return d.promise;
        },




        getActiveClientsWithBasicInformation: function (where) {
            var d = $q.defer();

            let filter:any = {};
            filter.where = where || undefined;
            $http.get(serverAddress.nodeURL + '/Clientes/listActiveClientsOnlyBasicInformation?filter=' + JSON.stringify(filter)).then(function (response) {
                d.resolve(response.data);
            }, function () {
                d.reject();
            });
            return d.promise;
        }
    };

    return service;
}]);